document.addEventListener("DOMContentLoaded", (event) => {

  // Lookbook page 
  
  let productLookbookEls = document.querySelectorAll('.product-lookbook');
  productLookbookEls.forEach(function(productLookbookEl) {
    
    let inner = productLookbookEl.querySelector('.items-inner');
    let arrowsEls = productLookbookEl.querySelectorAll('.arrows .arrow');
    let arrowLeft = productLookbookEl.querySelector('.arrows .arrow.left');
    let arrowRight = productLookbookEl.querySelector('.arrows .arrow.right');
    
    arrowsEls.forEach(function(arrowEl) {
      arrowEl.addEventListener('click', function() {
        if(this.classList.contains('deactive')) return;
        let curItem = parseInt(inner.dataset.currentProduct);
        let maxItems = productLookbookEl.querySelectorAll('.items .item').length;
        let elWidth = productLookbookEl.querySelector('.items .item').clientWidth;
        let innerParentWidth = inner.parentNode.clientWidth;
        let itemsShown = Math.round(innerParentWidth / elWidth);
        
        if(this.classList.contains('right')) {
          if(maxItems > (curItem + (itemsShown - 1))) {
            
            let curMarginLeft = parseFloat(inner.style.marginLeft) || 0;
            inner.style.marginLeft = (curMarginLeft - elWidth)+'px';
            arrowLeft.classList.remove('deactive');
            
            inner.dataset.currentProduct = (curItem + 1);

            if((maxItems - curItem) == itemsShown) {
              arrowRight.classList.add('deactive');
            }
          } else arrowRight.classList.add('deactive');
        } 
          
        else if(this.classList.contains('left')) {
          if(curItem > 1) {
            
            let curMarginLeft = parseFloat(inner.style.marginLeft) || 0;
            inner.style.marginLeft = (curMarginLeft + elWidth)+'px';
            arrowRight.classList.remove('deactive');
            
            inner.dataset.currentProduct = (curItem - 1);

            if(curItem == 2) {
              arrowLeft.classList.add('deactive');
            }
          } else arrowLeft.classList.add('deactive');
          
        }
      });
    });
  });


  // Product page. Other colors

  let otherColorsEl = document.querySelector('.other-colors .block-inner');
  let colorsClasses = otherColorsEl?.classList;
  if(colorsClasses?.contains('with-arrows') ||
    (window.innerWidth < 1100 && colorsClasses?.contains('colors-3'))) {
    otherColorsEl.dataset.manual = 'false';
    flickitySlider($(otherColorsEl));
  }

  function changeCurrency() {
    if(Shopify.country != 'PL') return;
    let productPricesEls = document.querySelectorAll('.money');
    productPricesEls.forEach(function(el) {
      el.innerText = el.innerText.replace('грн', 'Zł');
    });
    
    let currencyDiffer = 10;

    async function getCurrency() {
      const url = "https://cdn.shopify.com/s/javascripts/currencies.js";
      try {
        const response = await fetch(url);
        if (!response.ok) {
          addZlotyCurrency();
        }
    
        let text = await response.text();
        let zlotyRate = 0 + text.split('PLN:')[1].split(',')[0];
        let grivnyRate = 0 + text.split('UAH:')[1].split(',')[0];

        currencyDiffer = zlotyRate / grivnyRate;
        addZlotyCurrency();

      } catch (error) {
        addZlotyCurrency();
      }
    }
    getCurrency();

    function addZlotyCurrency() {
      
      let selectedPriceRangeEl = document.querySelectorAll('.gf-block-content .money');
      selectedPriceRangeEl.forEach(function(el) {
        el.innerText = (parseFloat(el.innerText.replace(' ', '')) / currencyDiffer).toFixed(2) + ' Zł';
        el.classList.add('adjusted');
      });
  
      let rangeInputsParent = document.querySelector('.gf-range-inputs');
      let doubledRangeInput = document.querySelector('.gf-range-inputs .doubled-input');
      if(!doubledRangeInput) {
        
        let minValue = document.querySelector('.gf-range-inputs .gf-range-min').value;
        let doubledInputMin = document.createElement('input');
        doubledInputMin.setAttribute('type', 'text');
        doubledInputMin.setAttribute('readonly', 'readonly');
        doubledInputMin.setAttribute('disabled', 'true');
        doubledInputMin.classList.add('doubled-input');
        doubledInputMin.classList.add('min');
        doubledInputMin.value = (minValue / currencyDiffer).toFixed(2);;
        rangeInputsParent.prepend(doubledInputMin);
        
        let maxValue = document.querySelector('.gf-range-inputs .gf-range-max').value;
        let doubledInputMax = document.createElement('input');
        doubledInputMax.setAttribute('type', 'text');
        doubledInputMax.setAttribute('readonly', 'readonly');
        doubledInputMax.setAttribute('disabled', 'true');
        doubledInputMax.classList.add('doubled-input');
        doubledInputMax.classList.add('max');
        doubledInputMax.value = (maxValue / currencyDiffer).toFixed(2);
        rangeInputsParent.querySelector('.gf-range-split').after(doubledInputMax);
      }
    }
    
  }


  /* Collection filter. Add SEO links */

  function addSEOLinksForFIlter() {
    
    let filterEls = document.querySelectorAll(`#gf-tree .gf-option-box button`);
    let seoCollections = document.querySelectorAll('.seo-collections .coll');
    
    seoCollections.forEach(function(coll) {
      
      let filterURL = coll.dataset.filterUrl;
      let relevantCollection = coll.dataset.relevantCollection;
      if(~filterURL.indexOf('&') || !relevantCollection) return;
      
      let mainCollection = coll.dataset.mainCollection;
      let collFilterId = filterURL.split('=')[0].replace('gf_', '');
      let collFilterName = filterURL.split('=')[1]?.replaceAll('%27', "'")?.toLowerCase();

      filterEls.forEach(function(filterEl) {
        
        let filterId = filterEl.dataset.fid;
        
        if(filterId && filterId == collFilterId) {
          let filterName = filterEl.dataset.fvalue?.toLowerCase().replaceAll(' ', '+');
          if(filterName && filterName == collFilterName) {
            let label = filterEl.querySelector('.gf-label');
            let labelHTML = label.innerHTML;
            let newLabelHTML = '<a href="' + relevantCollection + '">' + labelHTML + '</a>';
            label.innerHTML = newLabelHTML;
            filterEl.querySelector('a').addEventListener('click', function(e) {
              e.preventDefault();
            });
          }
        }
      });
      
    });
    
  }

  /*
  document.addEventListener('click', function(e) {
    if(e.target.closest('.gf-block-content')) {
      translateUrlParameters();
      setTimeout(function() {
        translateUrlParameters();
      }, 100);
      setTimeout(function() {
        translateUrlParameters();
      }, 200);
      setTimeout(function() {
        translateUrlParameters();
      }, 300);
    }
  });
  */


  /* Collection filer. Open filter */

  let filterButton = document.querySelector('#filterHeading');
  filterButton?.addEventListener('click', function() {
    let filterSidebar = document.querySelector('#gf-tree');
    if(window.innerWidth >= 768) {
      filterSidebar.classList.toggle('spf-hidden');
    } else {
      globofilter?.toggleCanvas();
    }
  });

  
  /* "Buy online" button */
  
  let buyOnlineButtons = document.querySelectorAll('.yv-main-product-detail .yv-pricebox-outer .buy-online');
  buyOnlineButtons.forEach(function(buyOnlineButton) {
    buyOnlineButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      scrollToOnlineStoresTab();
      return false;
    });
  });

  if(window.buyOnlineParameter) window.needToScrollToBuyOnline = true;

  function scrollToOnlineStoresTab() {

    let onlineStoresTab = document.querySelector('.yv-product-detail-tabs .yv-tab-product-item[content="tabContentWrapper"]');
    onlineStoresTab.click();

    const y = onlineStoresTab.getBoundingClientRect().top + window.scrollY;
    window.scroll({
      top: y,
      behavior: 'smooth'
    });
    
  }


  /* Blog page. Category select */

  let categoryButton = document.querySelector('.blog-filter-box .filter-tags');
  if(window.innerWidth < 950 && categoryButton) {
    categoryButton.addEventListener('click', function() {
      this.classList.toggle('active');
    });
  }


  /* Header. Open products catalog */

  let headerAllProductsLink = document.querySelector('header .nav__header.nav_2 a[href*="/collections/all"');
  headerAllProductsLink.addEventListener('click', function(e) {
    e.preventDefault();
    let menuNavEl = document.querySelector('.navbar-toggler');
    menuNavEl.click();
    return false;
  })


  // Translate Collection filters

  function checkPhrases() {
    let elemsArray = document.querySelectorAll(`#gf-tree .gf-option-block ul.gf-option-box button .gf-label,
                                                .globo-selected-items span.selected-item .gf-label,
                                                .custom-labels.left .custom-label`);
    elemsArray.forEach(function(el) {
      if(el.classList.contains('translated') || el.dataset.lyMutationCount) return;
      let text = el?.innerText?.trim().toLowerCase();
      if(text) {
        if(!globalTranslatedPhrases[text] && !globalTranslatedPhrases[text.toLowerCase()]) return;
        let phrase = translateIt(text);
        if(phrase) {
          el.innerText = phrase;
          if(el.classList.contains('custom-label')) {
            el.classList.add('label-' + phrase.replaceAll(' ', '-').replaceAll("'", "-").replaceAll('"', "-"));
          }
        }
        el.classList.add('translated');
      }
    });

    elemsArray = document.querySelectorAll(`#gf-tree .gf-option-block ul.gf-option-box button11`);
    elemsArray.forEach(function(el) {
      if(el.classList.contains('translated') || el.dataset.lyMutationCount) return;
      let text = el.dataset.fvalue;
      if(text) {
        if(!globalTranslatedPhrases[text]) text = text.toLowerCase();
        let phrase = translateIt(text);
        if(phrase) el.setAttribute('title', phrase);
      }
    });
    
    let filterEls = document.querySelectorAll('#gf-tree .gf-block-content');
    filterEls.forEach(function(filterEl) {
      filterEl.classList.add('to-show');
    });
    setTimeout(function() {
      filterEls.forEach(function(filterEl) {
        filterEl.classList.add('to-show');
      });
    }, 100);
  }
  
  function translateIt(text) {
    if(!globalTranslatedPhrases[text]) return text;
    let lang = 'ukrainian';
    if(Shopify.locale == 'ru') lang = 'russian';
    else if(Shopify.locale == 'pl') lang = 'polish';
    else if(Shopify.locale == 'en') lang = 'english';
    return globalTranslatedPhrases[text][lang];
  }

  // Налаштування MutationObserver
  function initObserver() {
    // Шукаємо основний контейнер фільтрів. Якщо його ще немає, спостерігаємо за body
    const targetNode = document.getElementById('gf-tree') || document.body; 
    
    if (!targetNode) return;

    const config = { childList: true, subtree: true };
    let debounceTimer;

    const observer = new MutationObserver((mutationsList, observer) => {
      // Використовуємо debounce, щоб не викликати checkPhrases 100 разів при рендері списку
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        checkPhrases();
      }, 50); 
    });

    observer.observe(targetNode, config);
  }

  // Ініціалізуємо обзервер після завантаження DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initObserver);
  } else {
    initObserver();
  }

  // Залишаємо специфічні події Globo Filter для інших ваших задач (SEO лінки, валюта тощо)
  window.addEventListener("globoFilterRenderCompleted", function(e) {

    // translateUrlParameters();
    if(typeof changeCurrency === 'function') changeCurrency();
    if(typeof addSEOLinksForFIlter === 'function') addSEOLinksForFIlter();

    /*
    if(Shopify.locale != 'uk' && window.location.search) {
      window.history.replaceState({}, null, '?');
    }
    */
   
  });
  
});

